<nx-message *ngIf="!field.closed" [context]="field.type" [closable]="field.closable" (close)="onClose()" class="nx-margin-bottom-xs">
  <div [innerHTML]="field.text | translate"></div>
</nx-message>
